/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from "react";
import { connect } from "react-redux";
import containsLongRunningProcess from "components/hoc/containsLongRunningProcess";
import requireAuth from "components/hoc/requireAuth";
import Survey from "components/survey/Survey";
import Pagination from "react-js-pagination";
import { Trans } from "react-i18next";
import i18next from "i18next";
import Helpers from "util/helpers";

class Surveys extends Component {
  state = {
    filteredData: [],
    filterTerm: "",
    error: null,
    activePage: 1,
    sort_by: "trName",
    sort_dir: "desc",
  };

  settings = {
    itemsPerPage: 10,
  };

  componentDidMount() {
    this.setState({ filteredData: this.props.surveys });
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.surveys !== this.props.surveys) {
      this.setState({ filteredData: this.props.surveys });
    }

    if (this.state.filterTerm !== prevState.filterTerm) {
      this.setState({
        filteredData: this.props.surveys.filter((item) => {
          return (
            Helpers.getTurkishCharaterFixedList(item.survey.name).includes(
              Helpers.getTurkishCharaterFixedList(this.state.filterTerm)
            ) ||
            Helpers.getTurkishCharaterFixedList(item.subject).includes(
              Helpers.getTurkishCharaterFixedList(this.state.filterTerm)
            )
          );
        }),
        activePage: 1,
      });
    }
  }

  handlePageChange = (pageNum) => {
    this.setState({ activePage: pageNum });
  };

  handleFilter = (e) => {
    this.setState({ filterTerm: e.target.value, activePage: 1 });
  };

  renderSearchBar = () => {
    return (
      <div className="col-xs-12 col-sm-12 col-md-3 col-lg-4 tableSearchArea">
        <div className="inner-addon right-addon">
          <span className="iconmford fo-icon-search"></span>
          <input
            type="text"
            name="tableSearch"
            id="tableSearch"
            className="form-control"
            placeholder={i18next.t("10053")}
            onChange={(e) => this.handleFilter(e)}
            value={this.state.filterTerm}
          />
        </div>
      </div>
    );
  };

  renderHeaderToolbar = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginRight: "20px",
          marginLeft: "20px",
        }}
      >
        {this.renderSearchBar()}

        <Pagination
          hideFirstLastPages={true}
          prevPageText={i18next.t(10110)}
          nextPageText={i18next.t(10111)}
          hideDisabled={true}
          hideNavigation={true}
          activePage={this.state.activePage}
          itemsCountPerPage={this.settings.itemsPerPage}
          totalItemsCount={
            this.state.filteredData?.length > 0
              ? this.state.filteredData.length
              : 0
          }
          onChange={(e) => this.handlePageChange(e)}
          itemClass="page-item"
          linkClass="page-link"
        />
      </div>
    );
  };

  renderFooterToolbar = () => {
    return (
      <div className="table-footer-toolbar">
        {/* <button className="export-button" onClick={this.handleExportCSV}>
          <Trans desc="Dışa Aktar">10113</Trans>
        </button> */}
      </div>
    );
  };

  trName = "";
  trSubject = "";

  reOrder = (orderBy) => {
    let sort_dir = "asc";
    if (this.state.sort_dir === "asc") sort_dir = "desc";
    this.setState({
      sort_by: orderBy,
      sort_dir: sort_dir,
    });
  };

  setSotingClassNames = () => {
    this.trName = "";
    this.trSubject = "";

    switch (this.state.sort_by) {
      case "trName":
        this.trName = `_${this.state.sort_dir}`;
        break;
      case "trSubject":
        this.trSubject = `_${this.state.sort_dir}`;
        break;
      default:
        this.trName = `_${this.state.sort_dir}`;
        break;
    }
  };

  renderData = (start, end) => {
    const sorted = this.state.filteredData.sort((a, b) => {
      switch (this.state.sort_by) {
        case "trName":
          return this.state.sort_dir === "desc"
            ? a.survey.name.localeCompare(b.survey.name)
            : b.survey.name.localeCompare(a.survey.name);
        case "trSubject":
          return this.state.sort_dir === "desc"
            ? a.subject.localeCompare(b.subject)
            : b.subject.localeCompare(a.subject);
        default:
          return this.state.sort_dir === "desc"
            ? a.survey.name.localeCompare(b.survey.name)
            : b.survey.name.localeCompare(a.survey.name);
      }
    });

    return sorted.slice(start, end).map((survey) => {
      return (
        <Survey
          key={survey.inviteId}
          survey={survey}
          fullname={this.props.fullname}
        />
      );
    });
  };

  render() {
    let start = this.settings.itemsPerPage * (this.state.activePage - 1);
    let end = start + this.settings.itemsPerPage;

    this.setSotingClassNames();

    return (
      <>
        {this.props.spinner}
        <div>{this.renderHeaderToolbar()}</div>
        <div
          className="col-xs-12 col-sm-12 col-md-12 col-lg-12"
          id="anketler"
          style={{ display: "block" }}
        >
          <table
            className="table display responsive dataTable no-footer dtr-none collapsed"
            id="dataTablePersonel"
          >
            <thead>
              <tr>
                <th
                  onClick={() => this.reOrder("trName")}
                  className={`all sorting${this.trName}`}
                >
                  <div className="tableTitle">
                    <Trans desc="Adı">10186</Trans>
                  </div>
                </th>
                <th
                  onClick={() => this.reOrder("trSubject")}
                  className={`desktop sorting${this.trSubject}`}
                >
                  <div className="tableTitle">
                    <Trans desc="Açıklaması">10187</Trans>
                  </div>
                </th>
                <th></th>
              </tr>
            </thead>
            <tbody>{this.renderData(start, end)}</tbody>
          </table>
        </div>
        <div>
          <hr />
          {this.renderFooterToolbar()}
        </div>
      </>
    );
  }
}

const mapStateToProps = ({ profile }) => {
  return {
    fullname: profile.general.fullname,
  };
};

export default connect(mapStateToProps, {})(
  containsLongRunningProcess(requireAuth(Surveys))
);